(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function countryCodeToFlagEmoji(code) {
      if (!code || code.length !== 2) return '';
      var chars = code.toUpperCase().split('').map(function (letter) {
        return 127397 + letter.charCodeAt(0);
      });
      return String.fromCodePoint.apply(null, chars);
    }

    document.querySelectorAll('[data-sl-flag]').forEach(function (el) {
      var code = el.getAttribute('data-country-code');
      var flag = countryCodeToFlagEmoji(code);
      if (flag) {
        el.textContent = flag;
      }
    });

    function initListicleHeadlineJump() {
      var title = document.querySelector('.sl-listicle__title');
      var target = document.getElementById('snaplock-reasons');
      if (!title || !target) return;

      var tabletDesktop = window.matchMedia('(min-width: 750px)');

      function syncHeadlineState() {
        if (tabletDesktop.matches) {
          title.setAttribute('role', 'link');
          title.setAttribute('tabindex', '0');
        } else {
          title.removeAttribute('role');
          title.removeAttribute('tabindex');
        }
      }

      function jumpToReasons(event) {
        if (!tabletDesktop.matches) return;
        if (event.type === 'keydown' && event.key !== 'Enter') return;
        if (event.type === 'keydown') event.preventDefault();

        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }

      title.addEventListener('click', jumpToReasons);
      title.addEventListener('keydown', jumpToReasons);
      syncHeadlineState();

      if (tabletDesktop.addEventListener) {
        tabletDesktop.addEventListener('change', syncHeadlineState);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initListicleHeadlineJump, { once: true });
    } else {
      initListicleHeadlineJump();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() { this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); window.removeEventListener('scroll', this.onScrollHandler); }
    createObserver() { let observer = new IntersectionObserver((entries, observer) => { this.headerBounds = entries[0].intersectionRect; observer.disconnect(); }); observer.observe(this.header); }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
    reveal() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky', 'animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset() { if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
    closeMenuDisclosure() { this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach(disclosure => disclosure.close()); }
    closeSearchModal() { this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal.close(false); }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snaplock-ctr-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (cents) => {
      const currency = window.Shopify?.currency?.active || 'USD';

      return new Intl.NumberFormat(
        document.documentElement.lang || 'en',
        {
          style: 'currency',
          currency
        }
      ).format(cents / 100);
    };

    const selectKachingSizeEverywhere = (targetLabel) => {
      const selects = document.querySelectorAll(
        '.kaching-bundles__bar-variant-select'
      );

      selects.forEach((select) => {
        const opt = Array.from(select.options).find((option) =>
          option.textContent.trim().startsWith(targetLabel)
        );

        if (!opt || select.value === opt.value) return;

        select.value = opt.value;

        select.dispatchEvent(new Event('change', { bubbles: true }));
        select.dispatchEvent(new Event('input', { bubbles: true }));
      });
    };

    const initialize = (root) => {
      if (root.dataset.slReady === 'true') return;

      root.dataset.slReady = 'true';

      const mainImage = root.querySelector('[data-sl-main-image]');
      const badge = root.querySelector('[data-sl-badge]');
      const stage = root.querySelector('.sl-hero__stage');
      const thumbnailStrip = root.querySelector('.sl-hero__thumbs');
      const bestsellerMediaId = stage?.dataset.slBestsellerMediaId || '';
      const thumbnails = Array.from(root.querySelectorAll('[data-sl-thumb]'));
      const mobileTrack = root.querySelector('[data-sl-mobile-track]');
      const mobileSlides = Array.from(root.querySelectorAll('[data-sl-mobile-slide]'));
      const mobileGalleryQuery = window.matchMedia('(max-width: 560px)');

      let leadMediaId = String(mainImage?.dataset.mediaId || '');
      let mediaSwapTimer;
      let mobileScrollTimer;

      const setActiveMedia = (mediaId, revealThumbnail = true) => {
        const normalizedMediaId = String(mediaId || '');
        let activeThumbnail;

        thumbnails.forEach((item) => {
          const isActive = item.dataset.mediaId === normalizedMediaId;

          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', String(isActive));

          if (isActive) activeThumbnail = item;
        });

        if (badge) {
          badge.hidden = normalizedMediaId !== bestsellerMediaId;
        }

        if (revealThumbnail) {
          activeThumbnail?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }
      };

      const syncMobileSlide = () => {
        if (
          !mobileTrack ||
          !mobileSlides.length ||
          !mobileGalleryQuery.matches
        ) {
          return;
        }

        const currentIndex = mobileSlides.reduce(
          (closestIndex, slide, index) => {
            const currentDistance = Math.abs(
              slide.offsetLeft - mobileTrack.scrollLeft
            );
            const closestDistance = Math.abs(
              mobileSlides[closestIndex].offsetLeft - mobileTrack.scrollLeft
            );

            return currentDistance < closestDistance
              ? index
              : closestIndex;
          },
          0
        );

        const activeSlide = mobileSlides[currentIndex];
        const mediaId = activeSlide.dataset.mediaId || '';
        const src = activeSlide.dataset.image || '';
        const alt = activeSlide.dataset.alt || '';

        setActiveMedia(mediaId);

        if (mainImage && src) {
          mainImage.dataset.mediaId = String(mediaId);
          mainImage.src = src;
          mainImage.alt = alt || mainImage.alt;
        }

      };

      const scrollMobileGalleryTo = (mediaId, behavior = 'smooth') => {
        if (!mobileTrack || !mobileSlides.length) return false;

        const targetIndex = mobileSlides.findIndex(
          (slide) => slide.dataset.mediaId === String(mediaId || '')
        );

        if (targetIndex < 0) return false;

        mobileTrack.scrollTo({
          left: mobileSlides[targetIndex].offsetLeft,
          behavior
        });

        return true;
      };

      const showMedia = ({ mediaId, src, alt, revealThumbnail = true }) => {
        if (!mainImage || !src) return;

        setActiveMedia(mediaId, revealThumbnail);

        mainImage.dataset.mediaId = String(mediaId || '');

        if (mobileGalleryQuery.matches) {
          scrollMobileGalleryTo(mediaId);

          mainImage.src = src;
          mainImage.alt = alt || mainImage.alt;

          return;
        }

        window.clearTimeout(mediaSwapTimer);

        mainImage.style.opacity = '0';

        mediaSwapTimer = window.setTimeout(() => {
          mainImage.src = src;
          mainImage.alt = alt || mainImage.alt;
          mainImage.style.opacity = '1';
        }, 120);
      };

      mobileTrack?.addEventListener(
        'scroll',
        () => {
          window.clearTimeout(mobileScrollTimer);

          mobileScrollTimer = window.setTimeout(
            syncMobileSlide,
            80
          );
        },
        { passive: true }
      );

      const showAdjacentMedia = (direction) => {
        if (!mainImage || thumbnails.length < 2) return;

        const leadThumbnail = thumbnails.find(
          (item) => item.dataset.mediaId === leadMediaId
        );

        const orderedThumbnails = leadThumbnail
          ? [leadThumbnail, ...thumbnails.filter((item) => item !== leadThumbnail)]
          : thumbnails;

        const currentMediaId = String(mainImage.dataset.mediaId || '');

        const currentIndex = orderedThumbnails.findIndex(
          (item) => item.dataset.mediaId === currentMediaId
        );

        const startingIndex = currentIndex >= 0 ? currentIndex : 0;

        const nextIndex =
          (startingIndex + direction + orderedThumbnails.length) %
          orderedThumbnails.length;

        const nextThumbnail = orderedThumbnails[nextIndex];

        showMedia({
          mediaId: nextThumbnail.dataset.mediaId,
          src: nextThumbnail.dataset.image,
          alt: nextThumbnail.dataset.alt || ''
        });
      };

      setActiveMedia(mainImage?.dataset.mediaId, false);

      // Mobile thumbnails show a faded forward/back arrow only when more
      // images are offscreen. Leave the existing desktop controls intact.
      const previousThumbnailButton = root.querySelector('[data-sl-gallery-previous]');
      const nextThumbnailButton = root.querySelector('[data-sl-gallery-next]');
      const syncThumbnailArrows = () => {
        if (!thumbnailStrip) return;
        if (!mobileGalleryQuery.matches) {
          if (previousThumbnailButton) previousThumbnailButton.hidden = false;
          if (nextThumbnailButton) nextThumbnailButton.hidden = false;
          return;
        }

        const maxScroll = Math.max(0, thumbnailStrip.scrollWidth - thumbnailStrip.clientWidth);
        const canScroll = maxScroll > 6;
        const atBeginning = thumbnailStrip.scrollLeft <= 5;
        const atEnd = thumbnailStrip.scrollLeft >= maxScroll - 5;
        if (previousThumbnailButton) previousThumbnailButton.hidden = !canScroll || atBeginning;
        if (nextThumbnailButton) nextThumbnailButton.hidden = !canScroll || atEnd;
      };
      let thumbnailArrowFrame = 0;
      const queueThumbnailArrowSync = () => {
        if (thumbnailArrowFrame) return;
        thumbnailArrowFrame = window.requestAnimationFrame(() => {
          thumbnailArrowFrame = 0;
          syncThumbnailArrows();
        });
      };
      if (thumbnailStrip) {
        thumbnailStrip.addEventListener('scroll', queueThumbnailArrowSync, { passive: true });
        window.addEventListener('resize', queueThumbnailArrowSync, { passive: true });
        if ('ResizeObserver' in window) {
          const thumbnailResizeObserver = new ResizeObserver(queueThumbnailArrowSync);
          thumbnailResizeObserver.observe(thumbnailStrip);
        }
        queueThumbnailArrowSync();
      }

      const scrollGallery = (direction) => {
        if (!thumbnailStrip) return;

        const distance = Math.max(
          thumbnailStrip.clientWidth * .82,
          180
        );

        thumbnailStrip.scrollBy({
          left: distance * direction,
          behavior: 'smooth'
        });
      };

      root
        .querySelector('[data-sl-gallery-previous]')
        ?.addEventListener('click', () => scrollGallery(-1));

      root
        .querySelector('[data-sl-gallery-next]')
        ?.addEventListener('click', () => scrollGallery(1));

      thumbnails.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          showMedia({
            mediaId: thumb.dataset.mediaId,
            src: thumb.dataset.image,
            alt: thumb.dataset.alt || ''
          });
        });
      });

      if (stage) {
        let swipeStart;

        stage.addEventListener('pointerdown', (event) => {
          if (mobileGalleryQuery.matches) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;

          swipeStart = {
            x: event.clientX,
            y: event.clientY,
            pointerId: event.pointerId
          };
        });

        stage.addEventListener('pointerup', (event) => {
          if (!swipeStart || event.pointerId !== swipeStart.pointerId) return;

          const deltaX = event.clientX - swipeStart.x;
          const deltaY = event.clientY - swipeStart.y;
          const threshold = Math.max(42, stage.clientWidth * .11);

          swipeStart = undefined;

          if (
            Math.abs(deltaX) < threshold ||
            Math.abs(deltaX) <= Math.abs(deltaY) * 1.15
          ) {
            return;
          }

          showAdjacentMedia(deltaX < 0 ? 1 : -1);
        });

        stage.addEventListener('pointercancel', () => {
          swipeStart = undefined;
        });

        stage.addEventListener('dragstart', (event) => {
          event.preventDefault();
        });

        stage.addEventListener('keydown', (event) => {
          if (
            event.key !== 'ArrowLeft' &&
            event.key !== 'ArrowRight'
          ) {
            return;
          }

          event.preventDefault();

          showAdjacentMedia(
            event.key === 'ArrowRight' ? 1 : -1
          );
        });
      }

      const zoomDialog = root.querySelector('[data-sl-zoom-dialog]');
      const zoomImage = root.querySelector('[data-sl-zoom-image]');
      const zoomClose = root.querySelector('[data-sl-zoom-close]');

      if (
        stage &&
        mainImage &&
        zoomDialog &&
        zoomImage &&
        zoomClose &&
        typeof zoomDialog.showModal === 'function'
      ) {
        let zoomPointerStart;
        let suppressNextZoomClick = false;

        const openZoom = () => {
          zoomImage.src = mainImage.currentSrc || mainImage.src;
          zoomImage.alt = mainImage.alt || '';

          document.body.classList.add('sl-hero-zoom-open');
          zoomDialog.showModal();
        };

        const closeZoom = () => {
          if (zoomDialog.open) {
            zoomDialog.close();
          }
        };

        stage.addEventListener('pointerdown', (event) => {
          zoomPointerStart = {
            x: event.clientX,
            y: event.clientY,
            id: event.pointerId
          };

          suppressNextZoomClick = false;
        });

        stage.addEventListener(
          'pointermove',
          (event) => {
            if (
              !zoomPointerStart ||
              event.pointerId !== zoomPointerStart.id
            ) {
              return;
            }

            if (
              Math.hypot(
                event.clientX - zoomPointerStart.x,
                event.clientY - zoomPointerStart.y
              ) > 12
            ) {
              suppressNextZoomClick = true;
            }
          },
          { passive: true }
        );

        stage.addEventListener('pointercancel', () => {
          zoomPointerStart = undefined;
          suppressNextZoomClick = true;
        });

        stage.addEventListener('pointerup', () => {
          zoomPointerStart = undefined;
        });

        stage.addEventListener('click', () => {
          if (suppressNextZoomClick) {
            suppressNextZoomClick = false;
            return;
          }

          openZoom();
        });

        stage.addEventListener('keydown', (event) => {
          if (
            event.key !== 'Enter' &&
            event.key !== ' '
          ) {
            return;
          }

          event.preventDefault();
          openZoom();
        });

        zoomClose.addEventListener('click', closeZoom);

        zoomDialog.addEventListener('close', () => {
          document.body.classList.remove('sl-hero-zoom-open');
          stage.focus();
        });
      }

      root.querySelectorAll('[data-sl-reviews-link]').forEach((reviewsLink) => {
        reviewsLink.addEventListener('click', (event) => {
          const href = reviewsLink.getAttribute('href');

          const target =
            (href ? document.querySelector(href) : null) ||
            document.querySelector('[id$="__snaplock_reviews"]');

          if (!target) return;

          event.preventDefault();

          const behavior = window
            .matchMedia('(prefers-reduced-motion: reduce)')
            .matches
            ? 'auto'
            : 'smooth';

          target.scrollIntoView({
            behavior,
            block: 'start'
          });
        });
      });

      root.querySelectorAll('[data-sl-size-guide]').forEach((guide) => {
        const openButton = guide.querySelector('[data-sl-size-open]');
        const modal = guide.querySelector('[data-sl-size-modal]');
        const closeButtons = guide.querySelectorAll('[data-sl-size-close]');
        const sizeSelectButtons = guide.querySelectorAll(
          '[data-sl-size-select]'
        );

        if (
          !openButton ||
          !modal ||
          typeof modal.showModal !== 'function'
        ) {
          return;
        }

        openButton.addEventListener('click', () => {
          modal.showModal();
        });

        closeButtons.forEach((button) => {
          button.addEventListener('click', () => {
            modal.close();
          });
        });

        sizeSelectButtons.forEach((button) => {
          button.addEventListener('click', () => {
            selectKachingSizeEverywhere(button.dataset.slSizeSelect);
            modal.close();
          });
        });

        modal.addEventListener('click', (event) => {
          if (event.target === modal) {
            modal.close();
          }
        });
      });

      const offerJump = root.querySelector('[data-sl-offer-jump]');

      if (offerJump) {
        let offerTarget;
        let offerTargetVisible = false;
        let offerTargetObserver;
        let offerRefreshFrame;

        const appStickyIsVisible = () => {
          const appSticky = document.querySelector(
            '.kaching-bundles-sticky-atc'
          );

          if (!appSticky) return false;

          const rect = appSticky.getBoundingClientRect();
          const style = window.getComputedStyle(appSticky);

          return (
            rect.width > 0 &&
            rect.height > 0 &&
            style.position === 'fixed' &&
            style.visibility !== 'hidden' &&
            style.opacity !== '0'
          );
        };

        const refreshOfferJump = () => {
          window.cancelAnimationFrame(offerRefreshFrame);

          offerRefreshFrame = window.requestAnimationFrame(() => {
            const mobile = window
              .matchMedia('(max-width: 900px)')
              .matches;

            const drawerOpen = document
              .querySelector('cart-drawer')
              ?.classList.contains('active');

            const unavailable = !mobile || !offerTarget;

            offerJump.hidden = unavailable;

            offerJump.classList.toggle(
              'is-inactive',
              !unavailable &&
                (
                  offerTargetVisible ||
                  appStickyIsVisible() ||
                  drawerOpen
                )
            );
          });
        };

        const connectOfferTarget = () => {
          if (offerTarget?.isConnected) return;

          const nextTarget = root.querySelector(
            'kaching-bundle, kaching-bundles-block, .kaching-bundles'
          );

          if (!nextTarget) return;

          offerTarget = nextTarget;

          offerTargetObserver?.disconnect();

          offerTargetObserver = new IntersectionObserver(
            (entries) => {
              offerTargetVisible =
                entries[0]?.isIntersecting || false;

              refreshOfferJump();
            },
            { threshold: 0.35 }
          );

          offerTargetObserver.observe(offerTarget);
          refreshOfferJump();
        };

        offerJump.addEventListener('click', () => {
          connectOfferTarget();

          if (!offerTarget) return;

          const behavior = window
            .matchMedia('(prefers-reduced-motion: reduce)')
            .matches
            ? 'auto'
            : 'smooth';

          offerTarget.scrollIntoView({
            behavior,
            block: 'start'
          });
        });

        const offerMutationObserver = new MutationObserver(() => {
          connectOfferTarget();
          refreshOfferJump();
        });

        offerMutationObserver.observe(root, {
          childList: true,
          subtree: true
        });

        window.addEventListener(
          'scroll',
          refreshOfferJump,
          { passive: true }
        );

        window.addEventListener(
          'resize',
          refreshOfferJump
        );

        connectOfferTarget();
        refreshOfferJump();
      }

      const variantsElement = root.querySelector('[data-sl-variants]');
      const optionSelects = Array.from(
        root.querySelectorAll('[data-sl-option]')
      );

      if (!variantsElement) return;

      const variants = JSON.parse(variantsElement.textContent);
      const price = root.querySelector('[data-sl-price]');
      const comparePrice = root.querySelector('[data-sl-compare-price]');
      const buttons = Array.from(root.querySelectorAll('[data-sl-add]'));

      let lastVariantId = String(
        root.querySelector('[data-sl-variant-id]')?.value || ''
      );

      const renderVariant = (variant) => {
        if (variant.featured_media?.preview_image?.src) {
          leadMediaId = String(variant.featured_media.id);

          showMedia({
            mediaId: variant.featured_media.id,
            src: variant.featured_media.preview_image.src,
            alt:
              variant.featured_media.alt ||
              variant.title ||
              mainImage?.alt ||
              '',
            revealThumbnail: false
          });
        }

        if (price) {
          price.textContent = formatMoney(variant.price);
        }

        if (comparePrice) {
          const showCompare =
            variant.compare_at_price &&
            variant.compare_at_price > variant.price;

          comparePrice.hidden = !showCompare;

          comparePrice.textContent = showCompare
            ? formatMoney(variant.compare_at_price)
            : '';
        }

        buttons.forEach((button) => {
          button.disabled = !variant.available;

          const label = button.querySelector('[data-sl-add-label]');

          if (label) {
            label.textContent = variant.available
              ? button.dataset.availableLabel
              : button.dataset.soldOutLabel;
          }
        });
      };

      const scrollToHeroMedia = () => {
        const mediaTarget = root.querySelector('#snaplock-product-gallery');

        if (!mediaTarget) return;

        const behavior = window
          .matchMedia('(prefers-reduced-motion: reduce)')
          .matches
          ? 'auto'
          : 'smooth';

        mediaTarget.scrollIntoView({
          behavior,
          block: 'start'
        });
      };

      const syncVariantById = (variantId, updateUrl = false) => {
        const normalizedId = String(variantId || '');

        if (
          !normalizedId ||
          normalizedId === lastVariantId
        ) {
          return;
        }

        const previousVariant = variants.find(
          (item) => String(item.id) === lastVariantId
        );

        const variant = variants.find(
          (item) => String(item.id) === normalizedId
        );

        if (!variant) return;

        lastVariantId = normalizedId;

        renderVariant(variant);

        if (
          previousVariant &&
          previousVariant.option1 !== variant.option1
        ) {
          scrollToHeroMedia();
        }

        if (!updateUrl) return;

        const url = new URL(window.location.href);

        url.searchParams.set('variant', variant.id);

        window.history.replaceState({}, '', url);
      };

      const updateVariant = () => {
        const values = optionSelects.map(
          (select) => select.value
        );

        const variant = variants.find((item) =>
          item.options.every(
            (value, index) => value === values[index]
          )
        );

        if (!variant) return;

        const hiddenId = root.querySelector(
          '[data-sl-variant-id]'
        );

        if (hiddenId) {
          hiddenId.value = variant.id;
        }

        syncVariantById(variant.id, true);

        hiddenId?.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      };

      const syncFromVariantInput = () => {
        const hiddenId = root.querySelector(
          '[data-sl-variant-id]'
        );

        syncVariantById(hiddenId?.value);
      };

      optionSelects.forEach((select) => {
        select.addEventListener(
          'change',
          updateVariant
        );
      });

      root.addEventListener('change', (event) => {
        if (event.target.matches('input[name="id"]')) {
          syncFromVariantInput();
        }
      });

      root.addEventListener('input', (event) => {
        if (event.target.matches('input[name="id"]')) {
          syncFromVariantInput();
        }
      });

      const variantObserver = new MutationObserver(
        syncFromVariantInput
      );

      variantObserver.observe(root, {
        attributes: true,
        attributeFilter: ['value'],
        childList: true,
        subtree: true
      });
    };

    document
      .querySelectorAll('[data-sl-hero]')
      .forEach(initialize);

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        const root = event.target.querySelector(
          '[data-sl-hero]'
        );

        if (root) {
          initialize(root);
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snaplock-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  const priceRow=document.querySelector('[data-sl-editorial-pricing]');
  const hero=document.querySelector('.sl-hero');
  if(!priceRow||!hero)return;
  function syncOfferPrices(){
    const block=hero.querySelector('kaching-bundles-block');
    if(!block)return;
    let deal;
    try{deal=JSON.parse(block.getAttribute('deal-block'));}catch{return;}
    const offers=[1,2].map(quantity=>deal?.dealBars?.find(bar=>bar.quantity===quantity&&bar.dealBarType==='quantity-break'));
    const prices=offers.map(offer=>{
      if(!offer)return '';
      const bar=Array.from(block.querySelectorAll('.kaching-bundles__bar')).find(node=>node.dataset.dealBarId===offer.id);
      const raw=bar?.querySelector('.kaching-bundles__bar-price')?.textContent||'';
      const firstPrice=raw.match(/(?:A\$|US\$|CA\$|\$|€|£|¥)\s*\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{1,2})?/);
      return firstPrice?.[0]?.replace(/\s+/g,'')||'';
    });
    if(prices.some(value=>!value)){priceRow.hidden=true;return;}
    priceRow.querySelector('[data-sl-editorial-single]').textContent=prices[0];
    priceRow.querySelector('[data-sl-editorial-bundle]').textContent=prices[1];
    priceRow.querySelector('[data-sl-editorial-currency]').textContent='';
    priceRow.hidden=false;
  }
  let pending=false;
  const observer=new MutationObserver(()=>{
    if(pending)return;
    pending=true;
    requestAnimationFrame(()=>{pending=false;syncOfferPrices();});
  });
  observer.observe(hero,{childList:true,subtree:true,characterData:true});
  syncOfferPrices();
})();

document.querySelectorAll('[data-sl-editorial-reviews]').forEach(link=>{
  function resolveReviewsTarget(){
    return document.querySelector('#looxReviews') ||
      document.querySelector('[id^="shopify-section-"][id*="snaplock_reviews"]') ||
      document.querySelector('[id*="snaplock_reviews"]');
  }
  const initial=resolveReviewsTarget();
  if(initial?.id)link.href='#'+initial.id;
  link.addEventListener('click',event=>{
    const target=resolveReviewsTarget();
    if(!target?.id)return; // Keep the native section hash as a fallback.
    link.href='#'+target.id;
    event.preventDefault();
    target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    if(history.replaceState)history.replaceState(null,'','#'+target.id);
  });
});
if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
  document.querySelectorAll('.sl-editorial video').forEach(video=>{video.autoplay=false;video.pause()});
}

  } catch(e) { console.error(e); }
})();
})();
